import moment from "moment";

class TableHelper {
	/**
	 * Filters table data using a FuzzySearcher instance.
	 * 
	 * @param {Object} table - The table configuration object
	 * @param {FuzzySearcher} searcher - The FuzzySearcher instance
	 * @param {Object} [options={}] - Filter options
	 * @param {string} [options.defaultSortBy] - The default sort key when not filtering
	 * @param {Function} [options.logger] - Debug logger function
	 */
	filter(table, searcher, options = {}) {
		const { defaultSortBy, logger } = options;

		if(table.filterBy === "" || table.filterBy === undefined || table.filterBy === null) {
			table.data = searcher.collection;
			if(table.isNoFilterSorted !== true && defaultSortBy) {
				table.actions.sort(defaultSortBy);
				table.actions.sort(defaultSortBy); //yes, twice, so that it'll sort ascending again.
				table.isNoFilterSorted = true;
			}
		}
		else {
			// FuzzySearcher.search() returns items with $match.rank (higher = better match)
			table.data = searcher.search(table.filterBy, { logger: logger?.debug.bind(logger) });
			options?.logger?.debug(`Filtering with term "${table.filterBy}" returned ${table.data.length} results.`, { data: table.data });
			table.isNoFilterSorted = false;
			table.actions.sort(null);
			table.actions.sort("$match.rank");
		}

		if(!!table.range && !!table.range.rangeBegin) {
			if(table.range.rangeBegin.isSame(moment(), "day")) {
				table.data = table.data.filter((item) => !item.LastLogin);
			}
			else {
				table.data = table.data.filter((item) => {
					if(!item.LastLogin) {
						return false;
					}

					return table.range.rangeBegin.isBefore(moment(item.LastLogin), "day");
				});
			}
		}
	}
}

export default angular
	.module("vesl.services.table-helper", [])
	.service("tableHelper", TableHelper).name;
